import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllReclamationsPage } from "src/components/views/erp/reclamation/allReclamationsPage/AllReclamationsPage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/reclamations")({
	staticData: { title: i18n.t("reclamations"), legacyViewKey: "allReclamationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <AllReclamationsPage isActive={isActive} />;
}
